"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductGroupFilterExcludesPlan = exports.HasProducts = exports.GetVisiblePlans = exports.GetCellCssClass = void 0;
var GetCellCssClass = exports.GetCellCssClass = function GetCellCssClass(_ref) {
  var planNumber = _ref.planNumber,
    planProductGroup = _ref.planProductGroup,
    activeProductGroup = _ref.activeProductGroup,
    isValueCell = _ref.isValueCell,
    labelDefinition = _ref.labelDefinition,
    selectedProduct = _ref.selectedProduct,
    productsAreMerged = _ref.productsAreMerged;
  var cssClasses = [];
  if (ProductGroupFilterExcludesPlan({
    productGroup: planProductGroup,
    activeProductGroup: activeProductGroup
  })) {
    cssClasses.push('disabled');
  }
  if (selectedProduct && (planNumber === selectedProduct.planNumber || productsAreMerged && selectedProduct.basePlanNo === planNumber)) {
    cssClasses.push('selected');
  }
  if (isValueCell) {
    cssClasses.push('productItemValue');
    if (labelDefinition && labelDefinition.valueType) {
      cssClasses.push(labelDefinition.valueType);
    }
  }
  return cssClasses.join(' ');
};
var HasProducts = exports.HasProducts = function HasProducts(_ref2) {
  var visiblePlans = _ref2.visiblePlans;
  return Object.values(visiblePlans).find(function (plan) {
    return typeof plan !== 'undefined';
  });
};
var ProductGroupFilterExcludesPlan = exports.ProductGroupFilterExcludesPlan = function ProductGroupFilterExcludesPlan(_ref3) {
  var productGroup = _ref3.productGroup,
    activeProductGroup = _ref3.activeProductGroup;
  if (!activeProductGroup || !activeProductGroup.productsGroups) {
    return false;
  }
  return activeProductGroup.productsGroups.indexOf(productGroup) === -1;
};
var GetVisiblePlans = exports.GetVisiblePlans = function GetVisiblePlans(_ref4) {
  var tableContext = _ref4.tableContext;
  var speciesFilter = tableContext.speciesFilter,
    FilterProducts = tableContext.FilterProducts,
    productsAreMerged = tableContext.productsAreMerged,
    staffMode = tableContext.staffMode,
    petSureStaffMode = tableContext.petSureStaffMode,
    DisplayOrders = tableContext.DisplayOrders,
    BaseProducts = tableContext.BaseProducts,
    AllPlans = tableContext.AllPlans,
    ProductGroupsKeyedByPlanNumber = tableContext.ProductGroupsKeyedByPlanNumber;
  if (speciesFilter !== 'all') {
    return FilterProducts({
      speciesFilter: speciesFilter,
      staffMode: staffMode,
      petSureStaffMode: petSureStaffMode,
      visiblePlans: productsAreMerged ? BaseProducts : AllPlans,
      groupDisplayOrders: DisplayOrders,
      productsAreGrouped: productsAreMerged,
      groupsKeyedByPlanNumber: ProductGroupsKeyedByPlanNumber
    });
  }
  if (productsAreMerged) {
    return BaseProducts;
  }
  return AllPlans;
};